import { Subject, ReplaySubject } from 'rxjs';
import { flog } from '@zambezi/caballo-vivo';
import createIntentSubject$ from '@apiEnabler/api-enabler-common/lib/intent-subject';
export var confirmLogOut$ = createIntentSubject$().pipe(flog('Confirm log out'));
export var cancelLogOut$ = createIntentSubject$().pipe(flog('Cancelled log out'));
export var startLogOut$ = new Subject().pipe(flog('Log out'));
export var extendSession$ = new Subject().pipe(flog('Extend current user session'));
export var renewSessionToken$ = new Subject().pipe(flog('Refresh expiration time'));
export var checkForUserInteraction$ = new Subject().pipe(flog('Check for user interaction'));
export var notifyTokenExpiration$ = new Subject().pipe(flog('Notify about Token expiration'));
export var userAuthNMethod$ = new ReplaySubject(1).pipe(flog('Select user authentication method'));